import { render, staticRenderFns } from "./Expiry-Listing.vue?vue&type=template&id=571a6f48&"
import script from "./Expiry-Listing.vue?vue&type=script&lang=js&"
export * from "./Expiry-Listing.vue?vue&type=script&lang=js&"
import style0 from "./Expiry-Listing.vue?vue&type=style&index=0&id=571a6f48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports